import { motion } from 'framer-motion';
import PageTransition from '../components/Motion/PageTransition';

/**
 * About Page - Company information with smooth animations
 * Respects prefers-reduced-motion via Framer Motion's built-in support
 */
function About() {
  const sectionVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        delay: i * 0.15,
        ease: [0.22, 1, 0.36, 1]
      }
    })
  };

  return (
    <PageTransition>
      <div className="bg-white py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <motion.h1
              className="text-4xl md:text-5xl font-bold text-gray-900 mb-8"
              initial="hidden"
              animate="visible"
              custom={0}
              variants={sectionVariants}
            >
              About Us
            </motion.h1>

            <div className="prose prose-lg max-w-none">
              <motion.p
                className="text-xl text-gray-700 mb-6 leading-relaxed"
                initial="hidden"
                animate="visible"
                custom={1}
                variants={sectionVariants}
              >
                At Real Value Group, we don’t just work with data—we unlock its power. We transform
                scattered information into clarity, confidence, and meaningful action. Our purpose
                is simple: turn data into real value for the organizations we serve.
              </motion.p>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={2}
                variants={sectionVariants}
              >
                <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Our Mission</h2>
                <p className="text-gray-700 mb-6">
                  To empower every business we work with to move faster, think smarter, and make
                  decisions grounded in truth—not guesswork. We exist to help leaders see what
                  others miss and act with certainty in a world full of complexity.
                </p>
              </motion.div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={3}
                variants={sectionVariants}
              >
                <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Our Vision</h2>
                <p className="text-gray-700 mb-6">
                  To build a future where data empowers people—helping leaders make wiser decisions,
                  teams work smarter, and businesses grow with confidence, integrity, and purpose.
                </p>
              </motion.div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                custom={4}
                variants={sectionVariants}
              >
                <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Our Values</h2>
                <ul className="space-y-6">
                  <li>
                    <p className="font-semibold text-gray-900">Excellence as a standard.</p>
                    <p className="text-gray-700">We deliver work we’re proud of—every time.</p>
                  </li>

                  <li>
                    <p className="font-semibold text-gray-900">Client success above all.</p>
                    <p className="text-gray-700">When our clients grow, we succeed with them.</p>
                  </li>

                  <li>
                    <p className="font-semibold text-gray-900">Innovation through teamwork.</p>
                    <p className="text-gray-700">Great ideas emerge when great minds collaborate.</p>
                  </li>

                  <li>
                    <p className="font-semibold text-gray-900">Integrity at our core.</p>
                    <p className="text-gray-700">Honesty, transparency, and trust guide every decision.</p>
                  </li>

                  <li>
                    <p className="font-semibold text-gray-900">A commitment to growth.</p>
                    <p className="text-gray-700">We learn, evolve, and continuously push the boundaries of what’s possible.</p>
                  </li>
                </ul>

              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </PageTransition>
  );
}

export default About;

